import React from 'react';
import { useCookieConsent } from '../lib/cookieConsent';

const GOOGLE_ANALYTICS_ID = 'G-GW7FJTYJ50';

type Gtag = (...args: unknown[]) => void;
type ConsentStatus = 'granted' | 'denied';
let isGoogleAnalyticsConfigured = false;

declare global {
  interface Window {
    gtag?: Gtag;
  }
}

function setGoogleConsent(status: ConsentStatus) {
  window.gtag?.('consent', 'update', {
    analytics_storage: status,
    ad_storage: status,
    ad_user_data: status,
    // Conversion measurement is enabled after consent; personalized ads are not.
    ad_personalization: 'denied',
  });
}

function configureGoogleAnalytics() {
  if (!window.gtag || isGoogleAnalyticsConfigured) return;

  isGoogleAnalyticsConfigured = true;
  window.gtag('js', new Date());
  window.gtag('config', GOOGLE_ANALYTICS_ID);
}

export default function GoogleTracking() {
  const { acceptsOptionalCookies } = useCookieConsent();

  React.useEffect(() => {
    if (!acceptsOptionalCookies) {
      setGoogleConsent('denied');
      return;
    }

    setGoogleConsent('granted');
    configureGoogleAnalytics();
  }, [acceptsOptionalCookies]);

  return null;
}
